import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../../Services/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getDatabase, ref, onValue } from 'firebase/database'; // Correct Firebase import
import { GoogleMap, Marker, useLoadScript, DirectionsRenderer, LoadScript, InfoWindow, OverlayViewF } from '@react-google-maps/api';
import { IoRefresh, IoNavigate } from "react-icons/io5";
import { PiScooterFill } from "react-icons/pi";
import rider_icon from '../../Assets/Images/icons/Ridersvg.jpg'
import store_icon from '../../Assets/Images/icons/Store.png'
import bike_icon from '../../Assets/Images/icons/Deliverer.png'
import user_location from "../../Assets/Images/icons/tabler_location-filled.png"
import { toast } from 'react-toastify';
import p_map_back from "../../Assets/Images/p_map_back.svg";
import p_map_location from "../../Assets/Images/p_map_location.svg";
import demo from '../../Assets/Images/default-placeholder.png'
import { LuPhoneCall } from "react-icons/lu";
import { TbMessage } from "react-icons/tb";
import NodeaxiosInstance from '../../Services/nodeaxios';

const mapContainerStyle = {
    width: "100%",
    height: "calc(100vh - 300px)",
    minHeight: "320px",
};

const DARK_MAP_STYLE = [
    { elementType: "geometry", stylers: [{ color: "#1d2233" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#a3a9bd" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#1d2233" }] },
    { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#3a4160" }] },
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#1f2b3a" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#2c3350" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#1d2233" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3b4470" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#0f1420" }] },
];

// round pin on the map, with an optional white name bubble above it
const MapPin = ({ position, label, size = 44, children }) => {
    if (!position) return null;
    return (
        <OverlayViewF
            position={position}
            mapPaneName="overlayMouseTarget"
            getPixelPositionOffset={(width, height) => ({ x: -(width / 2), y: -(height - size / 2) })}
        >
            <div className="liveTrackPin">
                {label ? <div className="liveTrackLabel">{label}</div> : null}
                {children}
            </div>
        </OverlayViewF>
    );
};

const initialCenter = { lat: 11.00675, lng: 76.92961 };

// delivery_status codes sent by get-order-delivery-details
const DELIVERY_STATUS_TEXT = {
    0: { title: 'Order Confirmed', subtitle: 'Your order has been placed.' },
    1: { title: 'Order Confirmed', subtitle: 'Your order has been confirmed.' },
    2: { title: 'Order ready', subtitle: 'Your order is ready for pickup soon!' },
    3: { title: 'Order picked up', subtitle: 'Your order has been picked up for delivery!' },
    // status 3 once the rider is live on the map
    OUT_FOR_DELIVERY: { title: 'Out for delivery', subtitle: 'Our delivery staff is on the way to deliver.' },
    4: { title: 'Arrived at location', subtitle: 'Your order has arrived at your location!' },
    5: { title: 'Delivered', subtitle: 'Your order has been delivered.' },
};

// pilot, flyer and staff come back with different field names
const getStaffInfo = (staff) => {
    if (!staff || typeof staff !== 'object') return { id: null, name: '', image: '', phone: '', type: '' };
    return {
        id: staff.pilotId || staff.pingledel_id || staff.staff_id || null,
        name: staff.pilot_name || staff.name || staff.staff_name || '',
        image: staff.pilot_image || staff.pingledel_image || staff.staff_image || '',
        phone: staff.phone_number || staff.staff_mbl || '',
        type: staff.delivery_staff_type || '',
    };
};

const DeliveryFlow = () => {
    const { order_id } = useParams(); // Destructure order_id from useParams
    const navigate = useNavigate();
    const [deliveryStaffId, setDeliveryStaffId] = useState(null);
    const [riderLocation, setRiderLocation] = useState(null);
    const [vendorLocation, setVendorLocation] = useState({});
    const [vendorDetails, setVendorDetails] = useState({});
    const [deliveryStaff, setDeliveryStaff] = useState({});
    const [userDetails, setUserDetails] = useState({});
    const [lastUpdate, setLastUpdate] = useState("");
    const [riderHeadingPosition, setRiderHeadingPosition] = useState(0);
    const [deliveryStatus, setDeliveryStatus] = useState(0);
    const [deliveryAddress, setDeliveryAddress] = useState();
    const [directions, setDirections] = useState(null);
    const [locaton, setLocaton] = useState('');
    const [locationPermission, setLocationPermission] = useState('');
    const [datas, setDatas] = useState("");
    const [eta, setEta] = useState("");
    const mapRef = useRef(null);
    const [refreshTick, setRefreshTick] = useState(0);
    const [secondsSinceUpdate, setSecondsSinceUpdate] = useState(0);
    const validVendorLocation = !isNaN(vendorLocation?.latitude) && !isNaN(vendorLocation?.longitude) && vendorLocation?.latitude !== undefined
        ? { lat: vendorLocation.latitude, lng: vendorLocation.longitude }
        : null;
    const staffInfo = getStaffInfo(deliveryStaff);
    const statusText = (Number(deliveryStatus) === 3 && riderLocation)
        ? DELIVERY_STATUS_TEXT.OUT_FOR_DELIVERY
        : (DELIVERY_STATUS_TEXT[Number(deliveryStatus)] || DELIVERY_STATUS_TEXT[1]);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: 'AIzaSyC7cC8d67-AjIHnXizRFxTj1uFkOwnF2zo', // Replace with your API key
    });

    useEffect(() => {
        fetchOrder();
        // getLocatonPermission()
    }, []);

    useEffect(() => {
        if (directions) {
            setEta(directions.routes[0].legs[0].duration.text);
        }
    }, [directions]);

    // keep the rider and the delivery address in view as the rider moves
    useEffect(() => {
        if (!mapRef.current || !window.google) return;
        const bounds = new window.google.maps.LatLngBounds();
        let points = 0;
        if (riderLocation) { bounds.extend(riderLocation); points++; }
        if (validVendorLocation) { bounds.extend(validVendorLocation); points++; }
        if (deliveryAddress && !isNaN(deliveryAddress.lat) && !isNaN(deliveryAddress.lng)) { bounds.extend(deliveryAddress); points++; }
        if (points === 0) return;
        if (points === 1) {
            mapRef.current.setCenter(riderLocation || deliveryAddress);
        } else {
            mapRef.current.fitBounds(bounds, 80);
        }
    }, [riderLocation, deliveryAddress, vendorLocation]);

    // "n Sec" since the route was last refreshed
    useEffect(() => {
        setSecondsSinceUpdate(0);
        const timer = setInterval(() => setSecondsSinceUpdate((sec) => sec + 1), 1000);
        return () => clearInterval(timer);
    }, [directions, refreshTick]);

    const handleRefresh = () => {
        fetchOrder();
        setRefreshTick((tick) => tick + 1);
    };

    const fetchOrder = async () => {
        try {
            const reqData = {
                order_id: order_id,
            };
            const response = await NodeaxiosInstance.post("product/get-order-delivery-details", reqData);
            if (response.status === 200) {
                const data = response.data; 
                setDatas(data)
                setVendorDetails(data?.vendor_detail);
                setVendorLocation({
                    latitude: Number(data?.vendor_detail?.vendor_lat),
                    longitude: Number(data?.vendor_detail?.vendor_long),
                });
                setDeliveryStaff(data?.delivery_staff_detail);
                setDeliveryStatus(data?.delivery_status);
                setUserDetails(data?.user_detail);

                const latlng = data?.delevery_address?.latlng;
                if (typeof latlng === 'string' && latlng.includes(',')) {
                    const [latitude, longitude] = latlng.split(",").map(Number);
                    setDeliveryAddress({
                        lat: Number(latitude),
                        lng: Number(longitude)
                    });
                }

                // pilot, flyer or staff id used for the Firebase live location
                setDeliveryStaffId(getStaffInfo(data?.delivery_staff_detail).id);
            }
        } catch (error) {
            console.error("Error fetching order details:", error);
        }
    };



    useEffect(() => {
        if (deliveryStaffId) {
            const db = getDatabase();
            const riderRef = ref(db, `/live_tracking/${deliveryStaffId}`);


            const unsubscribe = onValue(riderRef, (snapshot) => {
                const data = snapshot.val();
                // nothing published yet, or bad coordinates
                if (!data || isNaN(Number(data.latitude)) || isNaN(Number(data.longitude))) return;
                setRiderLocation({ lat: Number(data.latitude), lng: Number(data.longitude) });
                setLastUpdate(data.timestamp);
                setRiderHeadingPosition(data.heading);
            });

            return () => unsubscribe(); // Cleanup listener on unmount
        }
    }, [deliveryStaffId]);

    useEffect(() => {
        const fetchDirections = () => {
            if (riderLocation && deliveryAddress) {
                const directionsService = new window.google.maps.DirectionsService();
                directionsService.route(
                    {
                        origin: riderLocation,
                        destination: deliveryAddress,
                        travelMode: window.google.maps.TravelMode.DRIVING,
                    },
                    (result, status) => {
                        if (status == window.google.maps.DirectionsStatus.OK) {
                            

                            setDirections(result);
                        } else {
                            console.error("Error fetching directions:", status);
                        }
                    }
                );
            }
        };

        fetchDirections(); // Initial call

        const interval = setInterval(() => {
            fetchDirections(); // Refresh every 30 seconds
        }, 30000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, [riderLocation, deliveryAddress, refreshTick]);

    if (!isLoaded) return <div>Loading Map...</div>;



    return (


        <div className="bg-white  vh-100">
            <div className="position-relative">

                {/* the controls are positioned against the map only, not the bottom sheet */}
                <div className="position-relative">
                <GoogleMap
                    mapContainerStyle={mapContainerStyle}
                    center={initialCenter}
                    zoom={13}
                    onLoad={(map) => { mapRef.current = map; }}
                    options={{
                        mapTypeControl: false, // Hides the Map/Satellite button
                        streetViewControl: false,
                        fullscreenControl: false,
                        zoomControl: false,
                    }}
                >

                    <MapPin position={validVendorLocation} label={vendorDetails?.vendor_company_name}>
                        <div className="liveTrackCircle"><img src={store_icon} alt="" /></div>
                    </MapPin>

                    <MapPin position={deliveryAddress && !isNaN(deliveryAddress.lat) ? deliveryAddress : null} label={datas?.delevery_address?.location_type}>
                        <div className="liveTrackCircle"><IoNavigate size={22} color="#fff" /></div>
                    </MapPin>

                    <MapPin position={riderLocation} size={40}>
                        <div className="liveTrackCircle liveTrackRiderCircle"><PiScooterFill size={22} color="#fff" /></div>
                    </MapPin>

                    {directions && (
                        <>
                            <DirectionsRenderer
                                directions={directions}
                                options={{
                                    polylineOptions: {
                                        strokeColor: "#4E26A3",
                                        strokeOpacity: 0.95,
                                        strokeWeight: 5,
                                    },
                                    suppressMarkers: true,
                                }}
                            />
                        </>
                    )}
                </GoogleMap>
                <button
                    className="mapBackBtn position-absolute p-3 bg-white rounded-circle border-0"
                    onClick={() => {
                        navigate(-1)

                    }} >
                    <img src={p_map_back} width={"24px"} height={"24px"} />
                </button>

                <div className="liveTrackRefreshWrap position-absolute d-flex align-items-center gap-2">
                    <button className="liveTrackRefreshBtn ff-poppins-medium fs-16" onClick={handleRefresh}>
                        <IoRefresh size={20} /> Refresh
                    </button>
                    <div className="liveTrackSecBox ff-poppins-semiBold">
                        <div className="fs-18">{secondsSinceUpdate}</div>
                        <div className="fs-12">Sec</div>
                    </div>
                </div>
                </div>



                <div className="locationDetails" style={{
                    padding: 20,
                    position: 'relative',
                    marginTop: -24,
                    zIndex: 1,
                    borderTopLeftRadius: 24,
                    borderTopRightRadius: 24,
                    backgroundColor: '#fff',
                    width: '100%',
                }}>
                    <div className='map-modal-top d-flex justify-content-between'>
                        <div className='OrderStatus-right'>
                            <div className='ff-poppins-semiBold fs-20 primary-text'>
                                {statusText.title}
                            </div>
                            <div className='OrderStatus-subtitle fs-14'>
                                {statusText.subtitle}
                            </div>
                        </div>
                        <div className='OrderStatus-left'>
                            {directions && Number(deliveryStatus) < 5 && (
                                <>
                                    <div className='orderStatus-time fs-20 primary-text'>
                                        {Math.max(1, Math.ceil(directions.routes[0].legs[0].duration.value / 60))}
                                    </div>
                                    <div className='orderStatus-min fs-12'>Mins</div>
                                </>
                            )}
                        </div>
                    </div>
                    <div className='map-modal-mid'>
                        <div className='ff-poppins-semiBold fs-15'>Delivery Staff</div>
                        <div className='delivery-person-container'>
                            <div className='deliveryPerson-detail-left'>
                                <div className='delivery-person-image'>
                                    <img src={staffInfo.image || demo} alt='' height={'72px'} width={'72px'} style={{ borderRadius: '10px', objectFit: 'cover' }} onError={(e) => { e.target.onerror = null; e.target.src = demo; }} />
                                </div>
                                <div className='delivery-person-details'>
                                    <div className='delivery-person-name fs-16 ff-poppins-semiBold'>{staffInfo.name}</div>
                                    <div className='delivery-staff-badge fs-12 ff-poppins-regular'>{staffInfo.type}</div>
                                </div>
                            </div>
                            <div className='delivery-person-contact'>
                                <div className='delivery-person-call' onClick={() => navigate(`/chat/booking/${order_id}`, { state: { chatFlow: 'order' } })} >  <TbMessage size={24} /></div>
                                <div className='delivery-person-call' onClick={() => window.location.href = 'tel:' + staffInfo.phone} ><LuPhoneCall size={22} /></div>
                            </div>
                        </div>

                    </div>
                    <button className='returnToTicket ff-poppins-semiBold mt-4 mb-2' onClick={() => navigate(-1)}>
                        Return to ticket
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeliveryFlow;